import Logger from '@helpers/logger';

export default Logger.getLogger('Avaturn');
